(function() {
  'use strict';

  var checkoutSelector = 'button[name="checkout"]';

  function enableCheckout(button) {
    if (!button) {
      return;
    }

    if (button.disabled || button.hasAttribute('disabled')) {
      button.disabled = false;
      button.removeAttribute('disabled');
    }

    if (button.classList.contains('isDisabled')) {
      button.classList.remove('isDisabled');
    }

    if (button.getAttribute('aria-disabled') !== 'false') {
      button.setAttribute('aria-disabled', 'false');
    }
  }

  function watchCheckout(button) {
    if (!button || button.hasAttribute('data-checkout-guarded')) {
      return;
    }

    button.setAttribute('data-checkout-guarded', 'true');
    enableCheckout(button);

    var buttonObserver = new MutationObserver(function() {
      enableCheckout(button);
    });

    buttonObserver.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled']
    });
  }

  function findCheckoutButtons(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) {
      return;
    }

    if (root.nodeName === 'BUTTON' && root.getAttribute('name') === 'checkout') {
      watchCheckout(root);
    }

    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll(checkoutSelector), watchCheckout);
    }
  }

  function refreshCheckoutButtons() {
    findCheckoutButtons(document);
  }

  refreshCheckoutButtons();
  document.addEventListener('theme:cart:change', refreshCheckoutButtons);
  document.addEventListener('theme:cart:reload', refreshCheckoutButtons);

  function watchCartContainer(container) {
    if (container.hasAttribute('data-checkout-container-guarded')) {
      return;
    }

    container.setAttribute('data-checkout-container-guarded', 'true');
    findCheckoutButtons(container);

    // Cart sections can be updated with AJAX. Inspect only additions inside
    // those sections so unrelated app DOM changes never trigger cart scans.
    var cartObserver = new MutationObserver(function(mutations) {
      Array.prototype.forEach.call(mutations, function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, findCheckoutButtons);
      });
    });

    cartObserver.observe(container, { childList: true, subtree: true });
  }

  function watchCartContainers(root) {
    var cartContainerSelector = '[data-section-type="cart"], [data-section-type="cart-drawer"]';

    if (root.nodeType === 1) {
      var sectionType = root.getAttribute('data-section-type');
      if (sectionType === 'cart' || sectionType === 'cart-drawer') {
        watchCartContainer(root);
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll(cartContainerSelector), watchCartContainer);
  }

  watchCartContainers(document);
  document.addEventListener('shopify:section:load', function(event) {
    watchCartContainers(event.target);
  });

  function isHistoryNavigation(event) {
    if (event.persisted) {
      return true;
    }

    if (!window.performance) {
      return false;
    }

    if (typeof window.performance.getEntriesByType === 'function') {
      var navigationEntries = window.performance.getEntriesByType('navigation');
      if (navigationEntries.length && navigationEntries[0].type === 'back_forward') {
        return true;
      }
    }

    return window.performance.navigation &&
      window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD;
  }

  function refreshCartAfterHistoryNavigation(event) {
    if (!isHistoryNavigation(event)) {
      return;
    }

    function refreshCart() {
      window.fetch(window.theme.routes.cart + '.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error(response.statusText);
          }
          return response.json();
        })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
        })
        .catch(function(error) {
          console.error(error);
        });
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(refreshCart, { timeout: 500 });
    } else {
      refreshCart();
    }
  }

  window.addEventListener('pageshow', refreshCartAfterHistoryNavigation);

  var photoSwipePromise;

  function loadPhotoSwipe() {
    if (window.themePhotoswipe) {
      return Promise.resolve();
    }

    if (!photoSwipePromise) {
      photoSwipePromise = new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.src = window.theme.assets.photoswipe;
        script.onload = function() {
          if (window.themePhotoswipe) {
            resolve();
          } else {
            photoSwipePromise = null;
            reject(new Error('PhotoSwipe loaded without initializing.'));
          }
        };
        script.onerror = function() {
          photoSwipePromise = null;
          reject(new Error('PhotoSwipe failed to load.'));
        };
        document.head.appendChild(script);
      });
    }

    return photoSwipePromise;
  }

  function openProductZoom(trigger) {
    var container = trigger.closest('[data-section-type="product"]');
    var zoomWrapper = container && container.querySelector('[data-zoom-wrapper]');
    var productJson = container && container.querySelector('[data-product-json]');
    var mediaSlide = trigger.closest('[data-media-id]');

    if (!container || !zoomWrapper || !productJson || !mediaSlide) {
      throw new Error('Product zoom markup is incomplete.');
    }

    var product = JSON.parse(productJson.textContent);
    var mediaId = mediaSlide.getAttribute('data-media-id');
    var items = product.media
      .filter(function(media) {
        return media.media_type === 'image';
      })
      .map(function(media) {
        return {
          src: media.src,
          w: media.width,
          h: media.height,
          id: media.id
        };
      });
    var selectedIndex = -1;
    items.some(function(item, index) {
      if (item.id.toString() === mediaId.toString()) {
        selectedIndex = index;
        return true;
      }
      return false;
    });
    var PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
    var PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
    var options = {
      index: selectedIndex,
      showHideOpacity: true,
      showAnimationDuration: 150,
      hideAnimationDuration: 250,
      bgOpacity: 1,
      spacing: 0,
      allowPanToNext: false,
      maxSpreadZoom: 3,
      history: false,
      loop: true,
      pinchToClose: false,
      modal: false,
      closeOnScroll: false,
      closeOnVerticalDrag: true,
      getDoubleTapZoom: function(isMouseClick, item) {
        if (isMouseClick) {
          return 1.67;
        }
        return item.initialZoomLevel < 0.7 ? 1 : 1.3;
      },
      getThumbBoundsFn: function() {
        var imageLocation = container.querySelector('[data-product-slideshow]') ||
          container.querySelector('[data-product-image]');
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var rect = imageLocation.getBoundingClientRect();

        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      }
    };

    zoomWrapper.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

    var gallery = new PhotoSwipe(zoomWrapper, PhotoSwipeUI, items, options);
    gallery.init();
    gallery.listen('close', function() {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    });
  }

  // Product carousels clone slides after initialization. Event delegation keeps
  // zoom working on those clones because cloned DOM nodes do not retain direct
  // event listeners.
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest && event.target.closest('[data-deferred-zoom-button]');
    if (!trigger) {
      return;
    }

    event.preventDefault();

    if (trigger.getAttribute('aria-busy') === 'true') {
      return;
    }

    trigger.setAttribute('aria-busy', 'true');
    loadPhotoSwipe()
      .then(function() {
        openProductZoom(trigger);
      })
      .catch(function(error) {
        console.error(error);
      })
      .then(function() {
        trigger.removeAttribute('aria-busy');
      });
  });

  function hydrateDeferredProductImage(image) {
    if (!image || !image.hasAttribute('data-deferred-product-image')) {
      return;
    }

    var srcset = image.getAttribute('data-deferred-srcset');
    var src = image.getAttribute('data-deferred-src');

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }
    if (src) {
      image.setAttribute('src', src);
    }

    image.removeAttribute('data-deferred-product-image');
    image.removeAttribute('data-deferred-src');
    image.removeAttribute('data-deferred-srcset');
  }

  function hydrateDeferredNavigationImage(image) {
    if (!image || !image.hasAttribute('data-deferred-navigation-image')) {
      return;
    }

    var srcset = image.getAttribute('data-deferred-srcset');
    var src = image.getAttribute('data-deferred-src');

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }
    if (src) {
      image.setAttribute('src', src);
    }

    image.removeAttribute('data-deferred-navigation-image');
    image.removeAttribute('data-deferred-src');
    image.removeAttribute('data-deferred-srcset');
  }

  function hydrateNavigationDisclosure(trigger) {
    if (!trigger) {
      return;
    }

    var disclosureId = trigger.getAttribute('aria-controls');
    var disclosure = disclosureId && document.getElementById(disclosureId);
    if (!disclosure) {
      return;
    }

    Array.prototype.forEach.call(
      disclosure.querySelectorAll('[data-deferred-navigation-image]'),
      hydrateDeferredNavigationImage
    );
  }

  function navigationDisclosureTrigger(event) {
    var trigger = event.target.closest && event.target.closest('[data-hover-disclosure-toggle]');
    hydrateNavigationDisclosure(trigger);
  }

  document.addEventListener('pointerover', navigationDisclosureTrigger, { passive: true });
  document.addEventListener('focusin', navigationDisclosureTrigger);
  document.addEventListener('touchstart', navigationDisclosureTrigger, { passive: true });

  function hydrateProductMediaSlide(slide) {
    if (!slide) {
      return;
    }

    Array.prototype.forEach.call(
      slide.querySelectorAll('[data-deferred-product-image]'),
      function(image) {
        hydrateDeferredProductImage(image);

        // Promote the selected image so native lazy loading cannot leave the
        // newly visible hero stalled with an empty currentSrc.
        image.setAttribute('loading', 'eager');
        image.setAttribute('fetchpriority', 'high');
      }
    );
  }

  function findProductMediaSlide(gallery, mediaId) {
    var slides = gallery.querySelectorAll('[data-media-slide]');
    var id = mediaId === null || typeof mediaId === 'undefined' ? '' : mediaId.toString();

    for (var index = 0; index < slides.length; index += 1) {
      if (slides[index].getAttribute('data-media-id') === id) {
        return slides[index];
      }
    }

    return null;
  }

  function hydrateDeferredProductThumbnail(image) {
    if (!image || !image.hasAttribute('data-deferred-product-thumbnail')) {
      return;
    }

    var src = image.getAttribute('data-deferred-thumbnail-src');
    var clearLoadingState = function() {
      image.classList.remove('loading-shimmer');
    };

    image.addEventListener('load', clearLoadingState, { once: true });

    if (src) {
      image.setAttribute('src', src);
    }

    image.removeAttribute('data-deferred-product-thumbnail');
    image.removeAttribute('data-deferred-thumbnail-src');

    if (image.complete && image.naturalWidth > 1) {
      clearLoadingState();
    }
  }

  var deferredProductThumbnailObserver = 'IntersectionObserver' in window ?
    new IntersectionObserver(function(entries) {
      Array.prototype.forEach.call(entries, function(entry) {
        if (!entry.isIntersecting) {
          return;
        }

        deferredProductThumbnailObserver.unobserve(entry.target);
        hydrateDeferredProductThumbnail(entry.target);
      });
    }, { rootMargin: '250px' }) : null;

  function watchDeferredProductThumbnail(image) {
    if (deferredProductThumbnailObserver) {
      deferredProductThumbnailObserver.observe(image);
    } else {
      hydrateDeferredProductThumbnail(image);
    }
  }

  function findDeferredProductThumbnails(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-deferred-product-thumbnail]')) {
      watchDeferredProductThumbnail(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-deferred-product-thumbnail]'),
      watchDeferredProductThumbnail
    );
  }

  var deferredProductMediaGalleries = new WeakSet();
  var deferredProductMediaSections = new WeakSet();

  function watchDeferredProductMedia(gallery) {
    if (deferredProductMediaGalleries.has(gallery)) {
      return;
    }

    deferredProductMediaGalleries.add(gallery);
    gallery.removeAttribute('data-deferred-media-watched');

    hydrateProductMediaSlide(
      gallery.querySelector('[data-media-slide].is-selected') ||
      gallery.querySelector('[data-media-slide]')
    );

    gallery.addEventListener('theme:image:change', function(event) {
      if (!event.detail) {
        return;
      }

      hydrateProductMediaSlide(findProductMediaSlide(gallery, event.detail.id));
    });

    var selectedSlideObserver = new MutationObserver(function() {
      hydrateProductMediaSlide(gallery.querySelector('[data-media-slide].is-selected'));
    });

    selectedSlideObserver.observe(gallery, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

  function findDeferredProductMedia(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-product-slideshow]')) {
      watchDeferredProductMedia(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-product-slideshow]'),
      watchDeferredProductMedia
    );
  }

  function watchDeferredProductMediaSection(section) {
    if (deferredProductMediaSections.has(section)) {
      return;
    }

    deferredProductMediaSections.add(section);
    section.removeAttribute('data-deferred-media-section-watched');
    findDeferredProductMedia(section);
    findDeferredProductThumbnails(section);
  }

  function refreshDeferredProductMedia(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-section-type="product"]')) {
      watchDeferredProductMediaSection(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-section-type="product"]'),
      watchDeferredProductMediaSection
    );
  }

  var stickyAddToCartSections = new WeakSet();

  function watchStickyAddToCart(section) {
    if (
      !section ||
      stickyAddToCartSections.has(section) ||
      section.closest('[data-quickview-modal]')
    ) {
      return;
    }

    var buttons = section.querySelector('[data-sticky-add-to-cart]');
    var sentinel = section.querySelector('[data-sticky-add-to-cart-sentinel]');
    var wrapper = buttons && buttons.closest('[data-buttons-wrapper]');
    if (!buttons || !sentinel || !wrapper) {
      return;
    }

    stickyAddToCartSections.add(section);

    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var hasPassedButton = false;
    var isSticky = false;

    function setStickyAddToCart(active) {
      if (active === isSticky) {
        return;
      }

      isSticky = active;

      if (active) {
        wrapper.style.setProperty(
          '--sticky-add-to-cart-placeholder-height',
          buttons.getBoundingClientRect().height + 'px'
        );
      } else {
        wrapper.style.removeProperty('--sticky-add-to-cart-placeholder-height');
      }

      wrapper.classList.toggle('has-sticky-add-to-cart', active);
      buttons.classList.toggle('is-sticky-add-to-cart', active);
    }

    function syncStickyAddToCart() {
      setStickyAddToCart(mobileQuery.matches && hasPassedButton);
    }

    if ('IntersectionObserver' in window) {
      var sentinelObserver = new IntersectionObserver(function(entries) {
        Array.prototype.forEach.call(entries, function(entry) {
          hasPassedButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          syncStickyAddToCart();
        });
      });

      sentinelObserver.observe(sentinel);
    } else {
      var checkStickyAddToCart = function() {
        hasPassedButton = sentinel.getBoundingClientRect().bottom < 0;
        syncStickyAddToCart();
      };

      window.addEventListener('scroll', checkStickyAddToCart, { passive: true });
      checkStickyAddToCart();
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncStickyAddToCart);
    } else {
      mobileQuery.addListener(syncStickyAddToCart);
    }
  }

  function refreshStickyAddToCart(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    if (root.matches && root.matches('[data-section-type="product"]')) {
      watchStickyAddToCart(root);
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-section-type="product"]'),
      watchStickyAddToCart
    );
  }

  refreshDeferredProductMedia(document);
  refreshStickyAddToCart(document);
  document.addEventListener('shopify:section:load', function(event) {
    refreshDeferredProductMedia(event.target);
    refreshStickyAddToCart(event.target);
  });

  function findGridVariantPanel(gridItem, variantId) {
    var panels = gridItem.querySelectorAll('product-grid-item-variant[data-grid-item-variant]');

    for (var index = 0; index < panels.length; index += 1) {
      if (panels[index].getAttribute('data-grid-item-variant') === variantId) {
        return panels[index];
      }
    }

    return null;
  }

  function hydrateSelectedGridVariant(panel) {
    if (!panel) {
      return;
    }

    var targetImage = panel.querySelector('[data-slide-for-variant-media]') ||
      panel.querySelector('[data-grid-image]');

    if (!targetImage) {
      return;
    }

    Array.prototype.forEach.call(
      panel.querySelectorAll('[data-grid-image][data-grid-current-image]'),
      function(image) {
        if (image !== targetImage) {
          image.removeAttribute('data-grid-current-image');
        }
      }
    );

    // ProductGridItemImage expands its template when loading becomes eager.
    // Hydrate only the chosen color/sibling instead of every hidden panel.
    targetImage.setAttribute('loading', 'eager');
    targetImage.setAttribute('data-grid-current-image', 'true');
  }

  // Run before Pipeline's direct swatch click handler. This keeps touch and
  // keyboard selection working when hidden card images are template-wrapped.
  document.addEventListener('click', function(event) {
    var swatchLink = event.target.closest &&
      event.target.closest('product-grid-item a[data-grid-item-variant]');

    if (!swatchLink) {
      return;
    }

    var gridItem = swatchLink.closest('product-grid-item');
    var variantId = swatchLink.getAttribute('data-grid-item-variant');

    hydrateSelectedGridVariant(findGridVariantPanel(gridItem, variantId));
  }, true);

  // Some products use variant featured-image positions as gallery boundaries
  // instead of #group_variant alt-text tags. Prepare Pipeline's native image
  // filter during the capture phase so its existing listener can hide cells and
  // reload both Flickity sliders in the same variant-change event.
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    var featuredMedia = variant && (variant.featured_media || variant.featured_image);
    var groupPosition = featuredMedia && featuredMedia.position;

    if (!groupPosition || !event.target.closest) {
      return;
    }

    var productSection = event.target.closest('[data-section-type="product"]');
    var gallery = productSection && productSection.querySelector('[data-product-gallery-order-groups]');

    if (!gallery) {
      return;
    }

    var groupValue = String(groupPosition);
    var groupedMedia = productSection.querySelectorAll('[data-variant-media-group]');
    var visibleSlideCount = 0;

    Array.prototype.forEach.call(groupedMedia, function(mediaItem) {
      var mediaGroup = mediaItem.getAttribute('data-variant-media-group');
      var shouldShow = mediaGroup === '0' || mediaGroup === groupValue;

      if (shouldShow && mediaItem.hasAttribute('data-media-slide')) {
        visibleSlideCount += 1;
      }

      mediaItem.setAttribute(
        'data-image-filter',
        shouldShow ? '' : '__order_group_hidden__'
      );
    });

    gallery.classList.toggle(
      'product__grid--single-visible-media',
      visibleSlideCount === 1
    );

    // Pipeline resets every gallery cell when a variant image has no alt
    // text. Supply a temporary group token so its listener takes the normal
    // filtering path and reloads Flickity with only this color's cells.
    var variantImage = variant.featured_image;
    if (variantImage && variantImage.alt == null) {
      var originalAlt = variantImage.alt;
      var temporaryAlt = '#__order_group__';
      variantImage.alt = temporaryAlt;

      window.setTimeout(function() {
        if (variantImage.alt === temporaryAlt) {
          variantImage.alt = originalAlt;
        }
      }, 0);
    }
  }, true);

  var customWishlistButton = document.getElementById('custom-wishlist-button');
  if (!customWishlistButton) {
    return;
  }

  function bindWishlistButton() {
    var appWishlistButton = document.querySelector('.iwish-float-icon');
    if (!appWishlistButton) {
      return false;
    }

    customWishlistButton.addEventListener('click', function() {
      var currentAppWishlistButton = document.querySelector('.iwish-float-icon');
      if (currentAppWishlistButton) {
        currentAppWishlistButton.click();
      }
    });

    return true;
  }

  if (bindWishlistButton()) {
    return;
  }

  // iWish injects its button asynchronously. Stop observing as soon as it is
  // available, and resolve the current app button only when the shopper clicks.
  var wishlistObserver = new MutationObserver(function(mutations, observer) {
    var wishlistButtonAdded = Array.prototype.some.call(mutations, function(mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function(node) {
        return node.nodeType === 1 && (
          node.classList.contains('iwish-float-icon') ||
          node.querySelector('.iwish-float-icon')
        );
      });
    });

    if (wishlistButtonAdded && bindWishlistButton()) {
      observer.disconnect();
    }
  });

  wishlistObserver.observe(document.body, { childList: true, subtree: true });
})();
